/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.server.getCapabilities'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  notifications: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<NotificationConfig>((() => notificationConfig) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type NotificationConfig = {
  $type?: 'tools.ozone.server.getCapabilities#notificationConfig'
  channels: ('inApp' | 'push' | l.UnknownString)[]
}

export type { NotificationConfig }

const notificationConfig = /*#__PURE__*/ l.typedObject<NotificationConfig>(
  $nsid,
  'notificationConfig',
  /*#__PURE__*/ l.object({
    channels: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.string<{ knownValues: ['inApp', 'push'] }>(),
      { minLength: 1 },
    ),
  }),
)

export { notificationConfig }
